import { render, staticRenderFns } from "./ResourceFilters.vue?vue&type=template&id=cbb3e5ac&scoped=true&"
import script from "./ResourceFilters.vue?vue&type=script&lang=js&"
export * from "./ResourceFilters.vue?vue&type=script&lang=js&"
import style0 from "./ResourceFilters.vue?vue&type=style&index=0&id=cbb3e5ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb3e5ac",
  null
  
)

export default component.exports